import { createFeatureSelector, createSelector } from '@ngrx/store';

import { StoreConstants } from '@g3p/shared/constants/store.constants';

import { UserResetMfaState } from './user-reset-mfa-modal.state';

export const userResetMfaStore = createFeatureSelector<UserResetMfaState>(StoreConstants.customer);

export const isBusy = createSelector(userResetMfaStore, (state: UserResetMfaState) => state?.busy);
